@if (!editMode()) {
  <div class="card-header">
    <div class="card-header-info">
      @if (skill().group) {
        <span class="skill-group-tag">{{ skill().group!.name }}</span>
      }
      <div class="skill-name-row">
        <span class="skill-name">{{ skill().name }}</span>
        @if (expanded()) {
          <rt-icon-button iconName="edit" variant="plain" size="small" (click)="enterEdit()" />
        }
      </div>
      @if (skill().description) {
        <span class="skill-description">{{ skill().description }}</span>
      }
    </div>
    @if (!expanded()) {
      <rt-button variant="plain" (click)="toggleExpanded()">
        <rt-icon class="toggle-icon" name="keyboard-arrow-down" />
        {{
          'tlc.positions.import_skills_flow.summary_dialog.review_skills.view_levels_and_positions'
            | translate
        }}
      </rt-button>
    }
  </div>
}

<div class="collapsible-body" [class.expanded]="expanded() || editMode()">
  <div class="collapsible-body-inner">
    @if (editMode()) {
      <div class="skill-details-form" [formGroup]="form">
        <div class="skill-details-header">
          <span class="skill-details-heading">{{
            'tlc.positions.import_skills_flow.summary_dialog.review_skills.skill_details.heading'
              | translate
          }}</span>
          <div class="header-actions">
            <rt-button variant="primary" size="small" (click)="save()"
              >{{
                'tlc.positions.import_skills_flow.summary_dialog.review_skills.skill_details.save'
                  | translate
              }}
            </rt-button>
            <rt-button size="small" (click)="cancelEdit()"
              >{{
                'tlc.positions.import_skills_flow.summary_dialog.review_skills.skill_details.cancel'
                  | translate
              }}
            </rt-button>
          </div>
        </div>
        <div class="skill-details-form-fields">
          <rt-form-field>
            <rt-label
              >{{
                'tlc.positions.import_skills_flow.summary_dialog.review_skills.skill_details.area_of_expertise'
                  | translate
              }}
            </rt-label>
            <rt-select
              formControlName="groupName"
              [items]="groupItems()"
              [includeEmptyOption]="false"
            />
          </rt-form-field>
          <rt-form-field>
            <rt-label
              >{{
                'tlc.positions.import_skills_flow.summary_dialog.review_skills.skill_details.skill'
                  | translate
              }}
            </rt-label>
            <rt-input formControlName="name" />
          </rt-form-field>
          <rt-form-field>
            <rt-label
              >{{
                'tlc.positions.import_skills_flow.summary_dialog.review_skills.skill_details.description'
                  | translate
              }}
            </rt-label>
            <rt-input formControlName="description" />
          </rt-form-field>
        </div>
        @if (skill().matchedSkillId !== null) {
          <span class="skill-already-in-library">{{
            'tlc.positions.import_skills_flow.summary_dialog.review_skills.already_in_library'
              | translate
          }}</span>
        }
      </div>
    } @else {
      @if (skill().matchedSkillId !== null) {
        <span class="skill-already-in-library">{{
          'tlc.positions.import_skills_flow.summary_dialog.review_skills.already_in_library'
            | translate
        }}</span>
      }
    }

    @if (skill().proficiencies.length > 0) {
      <div class="proficiency-table">
        <span class="column-label">{{
          'tlc.positions.import_skills_flow.summary_dialog.review_skills.proficiency_levels'
            | translate
        }}</span>
        <span class="column-label">{{
          'tlc.positions.import_skills_flow.summary_dialog.review_skills.positions' | translate
        }}</span>
        <span class="column-label"></span>

        @for (proficiency of skill().proficiencies; track $index; let isLast = $last) {
          @if (editingProficiencyIndex() === $index) {
            <tlc-proficiency-edit-form
              [proficiency]="proficiency"
              [positionItems]="positionItems()"
              [class.no-border]="isLast"
              (save)="saveProficiency($index, $event)"
              (cancel)="cancelProficiencyEdit()"
              (delete)="deleteProficiency($index)"
            />
          } @else {
            <div class="proficiency-info" [class.no-border]="isLast">
              <div class="proficiency-level">
                <div class="proficiency-dots">
                  @for (_ of skill().proficiencies; track $index; let dotIndex = $index) {
                    <span class="dot" [class.filled]="dotIndex < proficiency.level"></span>
                  }
                </div>
                <span class="proficiency-name">{{ proficiency.name }}</span>
              </div>
              @if (proficiency.description) {
                <span class="proficiency-description">{{ proficiency.description }}</span>
              }
            </div>
            <div class="positions-info" [class.no-border]="isLast">
              <span>{{ proficiencyPositionNames(proficiency) }}</span>
            </div>
            <div class="proficiency-actions" [class.no-border]="isLast">
              <rt-icon-button
                iconName="edit"
                variant="plain"
                shape="square"
                size="small"
                (click)="enterProficiencyEdit($index)"
              />
            </div>
          }
        }
      </div>
    }

    <div class="decision-section">
      <rt-group variant="vertical stacked">
        <rt-radio
          [hasLensIcon]="true"
          [checked]="importDecision() === 'create-or-update'"
          (click)="setImportDecision('create-or-update')"
        >
          {{
            (skill().matchedSkillId !== null
              ? 'tlc.positions.import_skills_flow.summary_dialog.review_skills.update_skill'
              : 'tlc.positions.import_skills_flow.summary_dialog.review_skills.create_skill'
            ) | translate
          }}
        </rt-radio>
        <rt-radio
          [hasLensIcon]="true"
          [checked]="importDecision() === 'skip'"
          (click)="setImportDecision('skip')"
        >
          {{
            'tlc.positions.import_skills_flow.summary_dialog.review_skills.skip_skill' | translate
          }}
        </rt-radio>
      </rt-group>
      <rt-button variant="plain" (click)="toggleExpanded()">
        <rt-icon class="toggle-icon rotated" name="keyboard-arrow-up" />
        {{
          'tlc.positions.import_skills_flow.summary_dialog.review_skills.hide_levels_and_positions'
            | translate
        }}
      </rt-button>
    </div>
  </div>
</div>
